import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { getStageName, i18nIntl, isNotEmpty } from '../../lib/ep.js';

import DisabledArea from '../builder/DisabledArea';
import SearchField from '../builder/SearchField';
import Select from '../builder/Select';
import Spinner from '../builder/Spinner';
import { localizeFields } from '../builder/DynamicFields.js';

const Wrapper = (props) => {
	return (
		<aside class="gui_search stages_filter gui_not_in_bottom_big">
			{props.children}
		</aside>
	)
};

const StageFilter = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const default_filters = {
		stage_id:props?.stage_id ?? 'all',
		ranking_id:props?.ranking_id ?? 'all',
		search_value:props?.search_value ?? "",
	};
	const [ filters, setFilters ] = useState(default_filters);
	const [ has_more_data, setHasMoreData ] = useState(false);	// EDGARD: passar aquí si té usuaris per carregar
	const [ loading_all_data, setLoadingAllData ] = useState(false);

	const stages = props?.stages ?? [];
	const promotion = props?.promotion ?? {};
	const rankings = isNotEmpty(promotion, 'stage_rankings') ? localizeFields(promotion.stage_rankings, props.locale).filter((r) => r?.status ?? true) : [];
	const ranking_global = promotion?.stage_rankings_global ?? false;
	let available_stages = [];
	let available_rankings = [];
	if(rankings.length > 0 || ranking_global){
		if(ranking_global){
			available_rankings = [{ k:'all', v:`-- ${i18n("Global")} --` }];
		}
		rankings.map((ranking,i) => {
			available_rankings.push({
				k:ranking.id,
				v:`${ranking.title}`,
			});
		});
	} else {
		available_stages = [{ k:'all', v:`-- ${i18n("All stages")} --` }];
		stages.map((_stage) => {
			const stage = _stage.Stage;
			const stage_title = getStageName(stage, i18n);
			available_stages.push({
				k:stage.id,
				v:`${stage_title}${(stage.selected) ? " (*)" : ""}`,
			});
		});
	}

	const is_builder = props?.is_builder ?? false;
	const disable_stage_filter = props?.disable_stage_filter ?? false;
	const display_search_textual = props?.display_search_textual ?? true;

	let display_stage_selector = props?.display_stage_selector ?? true;
	if(available_stages.length < 3) display_stage_selector = false;

	if(!display_stage_selector && !display_search_textual) return null;

	const filterStages = (k, v) => {
		if(is_builder) return;
		const _filters = { ...filters, [k]:v };
		setFilters(_filters);
		
		if(props.onChange != undefined) props.onChange(k, v);
		if(props.onFilter != undefined) props.onFilter(_filters);
	};

	const loadAllData = () => {
		setLoadingAllData(true);

		// EDGARD: fer la funció per carregar els nous usuaris i, a l'acabar, fer el canvi aquest:
		setTimeout(() => {
			setHasMoreData(false);
			setLoadingAllData(false);
		}, 2000);
	};

	return (
		<Wrapper>
			{(available_rankings.length > 1) && (
					<Select
						name="ranking_id"
						_class={{ first:true }}
						values={available_rankings}
						value={filters['ranking_id']}
						model={filters}
						change={filterStages}
					/>
			)}
			
			{(display_stage_selector) && (
				<DisabledArea disabled={disable_stage_filter}>
					<Select
						name="stage_id"
						_class={{ first:true }}
						values={available_stages}
						model={filters}
						change={filterStages}
					/>
				</DisabledArea>
			)}

			{(display_search_textual) && (
				<div class="search_stages_field">
					<SearchField
						_class={{ first:true, other:'gui_flex_center' }}
						name="search_value"
						placeholder="Search by name"
						model={filters}
						change={filterStages}
					/>

					{(has_more_data) && (
						<div class="tapper" onClick={() => loadAllData()}>
							{(loading_all_data) && (
								<Spinner
									force_bg={true}
								>Loading data</Spinner>
							)}
						</div>
					)}
				</div>
			)}
		</Wrapper>
	)
}

export default injectIntl(StageFilter);